import type { Company } from "./Company.js";

export const fathersCompany = {
	cin: "06533604",
	vat: "CZ06533604",
	name: "Father’s Coffee Roastery s.r.o.",
} satisfies Company;

export const fathersContact = {
	email: "info@fathers.cz",
	phone: "+420736532744",
	socialProfiles: [
		"https://facebook.com/fatherscoffeeroastery/",
		"https://instagram.com/fathers_coffee_roastery/",
		"https://youtube.com/@fatherscoffee",
	],
} as const;
